/**
 * A refusal on sheet 50 (mission 9 WP13; FR-008, FR-014; research §1.18; squad U21, U25, S22;
 * contracts/ui-api.md "Common rules").
 *
 * An `ApiError` renders through the existing `ProblemBand`: the billing rows put the remedy as the lead
 * line and the reason sentence in the detail slot, register copy only (WP11). A 503 `try-again` on a
 * billing route has no row of its own, and `failureCopy` would show its `detail` verbatim; the server's
 * detail is never shown on this page (U25), so it renders `genericError` instead. A refused provider URL
 * is `providerUnavailable` (S22); anything else is `genericError`.
 */
import { Band } from '@/components/trellis/Band'
import { ProblemBand } from '@/components/trellis/ProblemBand'
import { ApiError } from '@/lib/api'
import type { ProblemOverrides } from '@/lib/problems'
import { UnsafeProviderUrlError } from '@/lib/provider-url'
import { copyText } from '@/lib/provisional-copy'

const OVERRIDES: ProblemOverrides = { 'try-again': { band: 'warning', remedy: 'genericError' } }

export function BillingProblem({ error }: { error: unknown }) {
  if (error instanceof ApiError) return <ProblemBand problem={error.problem} override={OVERRIDES} />
  return (
    <Band kind="blocked">
      <p>{copyText(error instanceof UnsafeProviderUrlError ? 'providerUnavailable' : 'genericError')}</p>
    </Band>
  )
}
